const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export const EXTRA_PRESETS = ["Food & Beverage", "Laundry", "Extra Bed", "Airport Pickup", "Minibar", "Room Service", "Spa", "Late Check-out"];

export const cleanExtras = (extras = []) =>
  extras
    .map((e) => ({ name: String(e.name || "").trim(), qty: Number(e.qty) || 0, price: Number(e.price) || 0 }))
    .filter((e) => e.name && e.qty > 0 && e.price >= 0);

export const computeInvoice = ({ rate, nights, rooms, discount = 0, gstRate = 0, extras = [] }) => {
  const n = Math.max(1, Number(nights) || 1);
  const rm = Math.max(1, Number(rooms) || 1);
  const ratePerNight = Number(rate) || 0;
  const ratePerRoom = r2(ratePerNight * n);
  const roomTotal = r2(ratePerRoom * rm);
  const items = cleanExtras(extras).map((e) => ({ ...e, amount: r2(e.qty * e.price) }));
  const extrasTotal = r2(items.reduce((s, e) => s + e.amount, 0));
  const subtotal = r2(roomTotal + extrasTotal);
  const disc = Math.min(subtotal, Math.max(0, Number(discount) || 0));
  const taxable = r2(subtotal - disc);
  const g = Number(gstRate) || 0;
  const gst = r2((taxable * g) / 100);
  const gross = r2(taxable + gst);
  const total = Math.round(gross);
  return { nights: n, rooms: rm, ratePerNight, ratePerRoom, roomTotal, items, extrasTotal, subtotal, discount: disc, taxable, gstRate: g, gst, cgst: r2(gst / 2), sgst: r2(gst - r2(gst / 2)), gross, roundOff: r2(total - gross), total };
};

export const invoiceFromBooking = (b) => {
  if (b.rate_per_night != null) {
    return computeInvoice({ rate: b.rate_per_night, nights: b.nights, rooms: b.rooms, discount: b.discount, gstRate: b.gst_rate, extras: b.extras });
  }
  const amount = Number(b.amount) || 0;
  const units = Math.max(1, b.nights) * Math.max(1, b.rooms || 1);
  const gstRate = amount / units > 7500 ? 18 : 12;
  const base = r2(amount / (1 + gstRate / 100));
  const inv = computeInvoice({ rate: base / units, nights: b.nights, rooms: b.rooms, gstRate });
  return { ...inv, total: amount, roundOff: r2(amount - inv.gross) };
};
